/**
 * BETA — avoir (credit-note) lifecycle.
 */
import { httpError } from "../router.js";
import { paginate, newId, nowIso, todayYmd, money, restoreStock } from "./_utils.js";

export function register(route) {
  route("GET", "/avoirs", (ctx) => {
    const { params, store } = ctx;
    let rows = [...store.data.avoirs];
    if (params.statut_paiement) rows = rows.filter((a) => a.statut_paiement === params.statut_paiement);
    if (params.type_avoir) rows = rows.filter((a) => a.type_avoir === params.type_avoir);
    if (params.fournisseur_id) rows = rows.filter((a) => a.fournisseur_id === params.fournisseur_id);
    if (params.achat_id) rows = rows.filter((a) => a.achat_id === params.achat_id);
    if (params.date_debut) rows = rows.filter((a) => a.date_avoir >= params.date_debut);
    if (params.date_fin) rows = rows.filter((a) => a.date_avoir <= params.date_fin);
    rows.sort((a, b) => (a.date_avoir > b.date_avoir ? -1 : 1));
    return paginate(rows, params);
  });

  route("GET", "/avoirs/:id", (ctx) => {
    const a = ctx.store.data.avoirs.find((x) => x.id === ctx.params.id);
    if (!a) httpError(404, "Avoir introuvable", "NOT_FOUND");
    return a;
  });

  route("POST", "/avoirs", (ctx) => {
    const body = ctx.body || {};
    const achat = ctx.store.data.achats.find((x) => x.id === body.achat_id);
    if (!achat) httpError(404, "Achat introuvable", "NOT_FOUND_ACHAT");
    const id = newId("avoir-new");
    const details = (body.details || []).map((d, i) => {
      const p = ctx.store.data.produits.find((x) => x.id === d.produit_id);
      return {
        id: `${id}-det-${i + 1}`,
        produit_id: d.produit_id,
        produit: p ? { nom_commercial: p.nom_commercial, ppa: p.ppa } : null,
        numero_lot: d.numero_lot || "",
        quantite: Number(d.quantite) || 0,
        prix_unitaire_ht: Number(d.prix_unitaire_ht) || 0,
        montant_ligne_ht: money(Number(d.quantite) * Number(d.prix_unitaire_ht)),
      };
    });
    const totalHt = body.type_avoir === "PRODUITS"
      ? details.reduce((s, d) => s + d.montant_ligne_ht, 0)
      : Number(body.montant_ht) || 0;
    const totalTtc = money(totalHt * 1.19);
    const created = {
      id,
      numero_interne: `AV-2026-${id.slice(-3).toUpperCase()}`,
      type_avoir: body.type_avoir || "FINANCIER",
      achat_id: achat.id,
      achat: { id: achat.id, numero_interne: achat.numero_interne, fournisseur_id: achat.fournisseur_id },
      fournisseur_id: achat.fournisseur_id,
      fournisseur: achat.fournisseur,
      date_avoir: body.date_avoir || todayYmd(),
      montant_ht: money(totalHt),
      montant_tva: money(totalTtc - totalHt),
      montant_ttc: totalTtc,
      statut_paiement: "NON_RECU",
      date_paiement: null,
      received_amount: null,
      notes_paiement: "",
      motif: body.motif || "",
      details: body.type_avoir === "PRODUITS" ? details : null,
      created_at: nowIso(),
      updated_at: nowIso(),
    };
    // PRODUITS: reverse stock
    if (created.type_avoir === "PRODUITS") {
      for (const d of created.details) {
        restoreStock(ctx.store, d.produit_id, -d.quantite); // negative = remove
      }
    }
    ctx.store.data.avoirs.unshift(created);
    ctx.commit();
    return created;
  });

  route("DELETE", "/avoirs/:id", (ctx) => {
    const a = ctx.store.data.avoirs.find((x) => x.id === ctx.params.id);
    if (!a) httpError(404, "Avoir introuvable", "NOT_FOUND");
    if (a.statut_paiement === "PAYE") httpError(400, "Avoir déjà payé — suppression interdite", "ALREADY_PAID");
    ctx.store.data.avoirs = ctx.store.data.avoirs.filter((x) => x.id !== a.id);
    ctx.commit();
    return { success: true };
  });

  route("POST", "/avoirs/:id/mark-paid", (ctx) => {
    const a = ctx.store.data.avoirs.find((x) => x.id === ctx.params.id);
    if (!a) httpError(404, "Avoir introuvable", "NOT_FOUND");
    a.statut_paiement = "PAYE";
    a.date_paiement = todayYmd();
    a.notes_paiement = ctx.body?.notes_paiement || "";
    if (a.type_avoir === "FINANCIER") {
      a.received_amount = Number(ctx.body?.received_amount) || a.montant_ttc;
    }
    a.updated_at = nowIso();
    ctx.commit();
    return a;
  });
}
